import tw, { styled } from 'twin.macro';

const PreviewMatch = styled.div`
  ${tw`my-3 text-center`}
`;

export default PreviewMatch;
